import { render, staticRenderFns } from "./AgentesPromotores.vue?vue&type=template&id=3a40b70a"
import script from "./AgentesPromotores.vue?vue&type=script&lang=js"
export * from "./AgentesPromotores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports